var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useState } from "react";
import { useTheme } from "styled-components";
import { Typo } from "../typography";
import { Icon } from "../icon";
import { StyledTag, StyledIconWrapper } from "./tag.style";
export function Tag(_a) {
    var { tagType = "simple", color = "default", label = "label", symbol = null, padding = "0.25rem 0.5rem 0.25rem 0.5rem", left, right, top, bottom, position } = _a, restProps = __rest(_a, ["tagType", "color", "label", "symbol", "padding", "left", "right", "top", "bottom", "position"]);
    const theme = useTheme();
    const [isShowTag, setIsShowTag] = useState(true);
    const [focused, setFocused] = useState(false);
    function getColor() {
        if (tagType === "simple") {
            switch (color) {
                case "default":
                    return theme.colors.black;
                case "success":
                    return theme.colors.success;
                case "warning":
                    return theme.colors.error;
                case "error":
                    return theme.colors.error;
                case "info":
                    return theme.colors.primaryDark;
                default:
                    return theme.colors.black;
            }
        }
        if (tagType === "removable") {
            if (color === "standard")
                return theme.colors.black;
            if (color === "highlight")
                return theme.colors.primaryDark;
        }
        return theme.colors.black;
    }
    const iconContainer = (_jsx(StyledIconWrapper, Object.assign({ isOnRight: false }, { children: _jsx(Icon, { symbol: symbol, width: "1rem", color: `${getColor()}` }) })));
    const closeIconContainer = (_jsx(StyledIconWrapper, Object.assign({ isOnRight: true }, { children: _jsx(Icon, { symbol: "Close", width: "1rem", color: `${getColor()}` }) })));
    const labelContainer = (_jsx(Typo, Object.assign({ variant: "label1", fontWeight: tagType === "highlight"
            ? theme.fontWeights.medium
            : theme.fontWeights.regular }, { children: tagType === "highlight" ? label.toUpperCase() : label })));
    const tagContainer = (_jsxs(StyledTag, Object.assign({}, restProps, { tagType: tagType, color: color, padding: padding, top: top, bottom: bottom, left: left, right: right, position: position, onClick: (e) => {
            if (tagType === "removable")
                setIsShowTag(false);
            e.preventDefault();
        }, onTouchEnd: (e) => {
            if (tagType === "removable")
                setIsShowTag(false);
            e.preventDefault();
        }, onMouseDown: () => setFocused(false), onKeyUp: () => setFocused(!focused), onBlur: () => setFocused(false), focused: focused, tabIndex: tagType === "removable" ? 0 : -1 }, { children: [!!symbol && iconContainer, !!label && labelContainer, tagType === "removable" && closeIconContainer] })));
    return _jsx(_Fragment, { children: isShowTag && tagContainer });
}
